import { Grid, MenuItem, Select, TextField } from '@mui/material';
import { createRef } from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { CostType, PalletType } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { getCostType } from '../calculationTypes';
import { getSelectedCalculationPricelistCurrency } from '../redux/calculationSelectors';

type OwnProps = {
    handleNameChange: (val: string) => void;
    handleAmountChange: (val: number) => void;
    handlePalletTypeChange: (val: number) => void;
    name: string;
    amount: number;
    palletType: PalletType | undefined;
};

const mapStateToProps = (state: RootState) => ({
    costType: state.calculation.showCreateNewCostDialog.costTypeId,
    isEditCostDialogLoading: state.calculation.isEditCostDialogLoading,
    currency: getSelectedCalculationPricelistCurrency(state)
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const PricePerPalletCostDialogContent = ({
    isEditCostDialogLoading,
    handleAmountChange,
    handleNameChange,
    handlePalletTypeChange,
    name,
    amount,
    currency,
    palletType
}: Props) => {
    const getAmountLabel = () => {
        return getCostType(currency, CostType.PerPallet!);
    };
    const amountInputRef = createRef();
    return (
        <div>
            <Grid container direction="column">
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth={true}
                    onChange={e => handleNameChange(e.target.value)}
                    value={name}
                    disabled={isEditCostDialogLoading}
                />
                <Select
                    sx={{ marginTop: '12px', marginBottom: '12px' }}
                    onChange={e => handlePalletTypeChange(e.target.value as PalletType)}
                    value={palletType}
                >
                    <MenuItem key={PalletType.EUR} value={PalletType.EUR}>
                        EUR
                    </MenuItem>
                    <MenuItem key={PalletType.SPA} value={PalletType.SPA}>
                        SPA
                    </MenuItem>
                </Select>

                <NumberFormat
                    getInputRef={amountInputRef}
                    customInput={TextField}
                    value={amount}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    onValueChange={e => {
                        if (e.value === '') {
                            handleAmountChange(0);
                        }

                        if (e.floatValue != null) {
                            handleAmountChange(e.floatValue);
                        }
                    }}
                    decimalSeparator=","
                    thousandSeparator={false}
                    isNumericString={true}
                    suffix={` ${getAmountLabel()}`}
                />
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(PricePerPalletCostDialogContent);
